export default __webpack_public_path__ + "static/media/devguide07.c33ac682.md";